import { Link } from "react-router-dom";

interface MovieCardProps {
  id: number;
  title: string;
  year: number;
  rating: number;
  category: string;
  posterUrl: string;
  showBadge?: boolean;
  badgeText?: string;
}

export default function MovieCard({
  id,
  title,
  year,
  rating,
  category,
  posterUrl,
  showBadge,
  badgeText,
}: MovieCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[2/3] bg-background-200">
        <img
          src={posterUrl}
          alt={title}
          title={`${title} - 天堂影视高清蓝光在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

        <div className="absolute top-2 right-2 bg-background-950/80 backdrop-blur-sm rounded-md px-2 py-0.5 flex items-center gap-1">
          <i className="ri-star-fill text-primary-500 text-xs"></i>
          <span className="text-xs font-semibold text-foreground-950">
            {rating}
          </span>
        </div>

        {showBadge && badgeText && (
          <div className="absolute top-2 left-2 bg-accent-500 text-background-50 text-xs font-medium px-2 py-0.5 rounded-md whitespace-nowrap">
            {badgeText}
          </div>
        )}

        <div className="absolute bottom-0 left-0 right-0 p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="inline-block text-xs text-background-50 bg-primary-500/90 rounded-md px-2 py-1 cursor-pointer">
            立即观看
          </span>
        </div>
      </div>

      <div className="mt-3">
        <h3 className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-600 transition-colors duration-200">
          {title}
        </h3>
        <div className="flex items-center gap-2 mt-1">
          <span className="text-xs text-foreground-400">{year}</span>
          <span className="text-xs text-foreground-300">·</span>
          <span className="text-xs text-foreground-400">{category}</span>
        </div>
      </div>
    </Link>
  );
}